export const JOBS_FILTERS_REDUCER_ACTIONS = {
  TOGGLE_DEPARTMENT: 'TOGGLE_DEPARTMENT',
  TOGGLE_CAMPUS: 'TOGGLE_CAMPUS',
  FILTER_SEARCHED_JOBS: 'FILTER_SEARCHED_JOBS',
  UPDATE_SEARCH_INPUT_VALUE: 'UPDATE_SEARCH_INPUT_VALUE',
  RESET_FILTERS: 'RESET_FILTERS',
}
